<mat-dialog-content>
  <form [formGroup]="form">
    <div class="form-section mat-elevation-z4">Protocol Details</div>

    <div class="mb-2" *ngIf="data.previousIrbNumber">
      <span class="mat-h4">Previous IRB Number: </span><span>{{ data.previousIrbNumber }}</span>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Study Title</mat-label>
          <input matInput formControlName="studyTitle" />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>IRBNet Number</mat-label>
          <input matInput formControlName="irbNetNumber" maxlength="250">
        </mat-form-field>
      </div>
      <div class="col-md-4 col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Status</mat-label>
          <mat-select formControlName="statusId">
            <mat-option *ngFor="let option of statusOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-4 col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Funding Agency</mat-label>
          <mat-select formControlName="fundingAgencyId">
            <mat-option *ngFor="let option of fundingAgency$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Nature of Research</mat-label>
          <mat-select formControlName="natureOfResearchId">
            <mat-option *ngFor="let option of natureOfResearch$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-4 col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Type of Research</mat-label>
          <mat-select formControlName="typeOfResearchId">
            <mat-option *ngFor="let option of researchTypeOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-4 col-sm-12" *ngIf="form.get('typeOfResearchId')?.value === sponsoredResearchTypeId">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Type of Sponsored Clinical Trials</mat-label>
          <mat-select formControlName="sponsoredClinicalTrialId">
            <mat-option *ngFor="let option of sponsoredClinicalTrial$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Ownership -->
    <div class="form-section mat-elevation-z4">Ownership</div>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Investigator</mat-label>
          <mat-select formControlName="investigatorId">
            <mat-option *ngFor="let option of investigatorOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Co-Investigator</mat-label>
          <input matInput formControlName="coInvestigator" maxlength="250">
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>NTRIRB Coordinator</mat-label>
          <mat-select formControlName="ntrIrbCoordinatorId">
            <mat-option *ngFor="let option of ntrCoordinatorOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>CR Coordinator</mat-label>
          <input matInput formControlName="crCoordinator" maxlength="250">
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Department</mat-label>
          <mat-select formControlName="departmentId">
            <mat-option *ngFor="let option of departmentOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>School</mat-label>
          <mat-select formControlName="schoolId">
            <mat-option *ngFor="let option of schoolOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
     
    </div>
    <div class="row">
      <div class="col-md-6 col-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Institution</mat-label>
          <mat-select formControlName="institutionId">
            <mat-option *ngFor="let option of institutionOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6 col-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Collaborating Institution</mat-label>
          <mat-select formControlName="collaboratingInstitutionId">
            <mat-option *ngFor="let option of collaboratingInstitutionOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Sponsorship -->
    <div class="form-section mat-elevation-z4">Sponsorship</div>
    <ng-container *ngIf="data.sponsorTypeCategories?.length; else noSponsorTypes">
      <div *ngFor="let sponsor of data.sponsorTypeCategories" class="row">
        <div class="col-md-3 col-sm-12">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Sponsor Type</mat-label>
            <input matInput [value]="sponsor.category?.name" disabled />
          </mat-form-field>
        </div>
        <div class="col-md-3 col-sm-12">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Sponsor</mat-label>
            <input matInput [value]="sponsor.subCategory?.name" disabled maxlength="250" />
          </mat-form-field>
        </div>
        <div class="col-md-4 col-sm-12">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Sponsor Protocol</mat-label>
            <input matInput [value]="sponsor.sponsorProtocol" disabled maxlength="250" />
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <ng-template #noSponsorTypes>
      <div class="row">
        <div class="col-md-3 col-sm-12">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Sponsor Type</mat-label>
            <input matInput value="—" disabled />
          </mat-form-field>
        </div>
        <div class="col-md-3 col-sm-12">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Sponsor</mat-label>
            <input matInput value="—" disabled maxlength="250" />
          </mat-form-field>
        </div>
        <div class="col-md-4 col-sm-12">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Sponsor Protocol</mat-label>
            <input matInput value="—" disabled maxlength="250" />
          </mat-form-field>
        </div>
      </div>
    </ng-template>

    <div class="form-section mat-elevation-z4">Review</div>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Type of Review</mat-label>
          <mat-select formControlName="typeOfReviewId">
            <mat-option *ngFor="let option of reviewTypeOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Review Cycle</mat-label>
          <mat-select formControlName="reviewCycleId">
            <mat-option *ngFor="let option of reviewCycleOptions$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="form.get('typeOfReviewId')?.value === cededReviewTypeId">
      <div class="col-md-6 col-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Irb of Record</mat-label>
          <mat-select formControlName="irbofRecordId">
            <mat-option *ngFor="let option of irbofRecords$ | async" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="form-section mat-elevation-z4">Special Findings</div>
    <div class="row">
      <div class="col-sm-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Special Findings Category</mat-label>
          <mat-select formControlName="specialFindingCategories" multiple>
            <mat-option *ngFor="let option of specialFindingOptions$ | async" [value]="option.id">
              {{ option.name }}
            </mat-option>
          </mat-select>

        </mat-form-field>

      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Special Findings Notes</mat-label>
          <textarea matInput formControlName="specialFindings" rows="5"></textarea>
        </mat-form-field>
      </div>
    </div>

    <div class="form-section mat-elevation-z4">Milestones</div>
    <div class="row">
      <div class="col-md-3" *ngFor="let field of ['submissionDate', 'initialReview', 'mostRecentReview', 'initialApprovalDate', 'approvalThrough', 'sendNextReview', 'continuingReviewDate', 'completeDate']">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ field | titlecase }}</mat-label>
          <input matInput [matDatepicker]="picker" [formControlName]="field" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker disabled="true"></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="justify-content-end">
  <button mat-stroked-button color="accent" mat-dialog-close>Close</button>
</mat-dialog-actions>
